import script from "./RewardDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./RewardDetail.vue?vue&type=script&lang=ts&setup=true"

import "./RewardDetail.vue?vue&type=style&index=0&id=f0e7364a&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0e7364a"]])

export default __exports__